import {ContextEnum} from '@/enums/context.enum';

export default class LogActionModel {
  constructor(context: ContextEnum, action: string, parameters: string) {
    this.context = context;
    this.action = action;
    this.parameters = parameters;
    const sessionId = sessionStorage.getItem('SESSION_ID');
    this.idSession = sessionId ? sessionId : '';
  }

  system: number  = 3; // System = Neodash
  idSession: string;
  context: string;
  action: string;
  parameters: string;
}
